import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'hashtag'
})
export class HashtagPipe implements PipeTransform {

  transform(text: string) {
    let text1;
    if (text.indexOf('#') !== -1) {
      text1 = text + ' ';
      const matches = text1.match(/#(.*?) /g);
      if (matches == null)
        return text;
      for (let i = 0; i < matches.length; i++) {
        let match = matches[i]
        let link = '/newsfeed?hashtag=' + match.replace('#', '')
        text1 = text1.replace(match, `<a href="{{link}}"><span class="hashtag-highlighted">` + match + `</span></a>`);
        text1 = text1.replace('{{link}}', link)
      }
    } else {
      text1 = text;
    }
    return text1;
  }

}


@Pipe({
  name: 'hashtagV2'
})
export class HashtagPipeV2 implements PipeTransform {

  transform(value: string, link: string | null): string {
    if (!value) return value;

    const hashtagRegex = /#(\w+)/g;
    // return value.replace(hashtagRegex, '<a class="hashtag" href="{{ link }}">#$1</a>');
    return value.replace(hashtagRegex, (match, tag) => {
      let hashtagLink = link?.replace(":hashtag:", tag)
      return `<a href="${hashtagLink}">#${tag}</a>`;
    });
  }
}
